// extracted by mini-css-extract-plugin
export default {"mobileHeight":"screen and (max-height: 824px)","root":"Status_root__NCXFn","path":"Status_path__t3+hY","complete":"Status_complete__70t2w"};